import React from "react";
import { PreviewSocialNetworks } from "@/features/previews/shared/components/PreviewSocialNetworks";
import { InitPreviewSocialLogos } from "@/features/previews/shared/components/InitPreviewSocialLogos/InitPreviewSocialLogos";

import type { QRProps } from "@/contexts/QREditorContext/types";

interface Mp3SocialSectionProps {
  data: NonNullable<QRProps<"mp3">["data"]>;
  isInitialPreview: boolean;
}

export const Mp3SocialSection = ({ data, isInitialPreview }: Mp3SocialSectionProps) => {
  if (data?.socialNetworks?.length > 0) {
    return (
      <PreviewSocialNetworks
        networks={data.socialNetworks}
        variant="mp3"
        className="mp3-template__social-networks"
      />
    );
  }

  if (isInitialPreview) {
    return (
      <div>
        <InitPreviewSocialLogos
          type="mp3"
          themeColor={data?.themeColor}
          className="mp3-template__social-logos"
          socialLogos={data?.socialLogos}
        />
      </div>
    );
  }

  return null;
};
